import { render, staticRenderFns } from "./ResourcePanelView.vue?vue&type=template&id=64ad3680&scoped=true&"
import script from "./ResourcePanelView.vue?vue&type=script&lang=js&"
export * from "./ResourcePanelView.vue?vue&type=script&lang=js&"
import style0 from "./ResourcePanelView.vue?vue&type=style&index=0&id=64ad3680&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ad3680",
  null
  
)

export default component.exports